import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ApiService } from "../core";
import { ExternalFeature, ExternalFeatureWithDependencyGetDto } from "../dto";
import { ExternalFeatureCategories } from "../enums";

@Injectable({ providedIn: "root" })
export class PlatformService {
  protected serviceUrl = "platform";

  constructor(protected api: ApiService) {}

  getExternalFeatureByCode(externalFeatureCode: string): Observable<string> {
    return this.getConfiguredAccountExternalFeaturesByCategory(ExternalFeatureCategories.AdvancedMarketingTools).pipe(
      map((data) => data.find((f) => f.code === externalFeatureCode)?.url || "")
    );
  }

  /** @deprecated Use `/externalFeatures/account/all` instead */
  getConfiguredAccountExternalFeatures(): Observable<ExternalFeature[]> {
    return this.api.get(`${this.serviceUrl}/externalFeatures/account/configured`);
  }

  getConfiguredAccountExternalFeaturesByCategory(categoryId: ExternalFeatureCategories): Observable<ExternalFeature[]> {
    return this.api.get(`${this.serviceUrl}/externalFeatures/account/configured/${categoryId}`);
  }

  getAllAccountExternalFeatures(): Observable<ExternalFeatureWithDependencyGetDto[]> {
    return this.api.get(`${this.serviceUrl}/externalFeatures/account/all`);
  }
}
